export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/buyCarIconDisabled.eeb2e066.svg","height":20,"width":31,"blurWidth":0,"blurHeight":0};